// extracted by mini-css-extract-plugin
module.exports = {"link":"_3wqEk","root":"_3vc75","label":"_1Qnnq"};